<template>
    <div class="breadcrumbs px-mob py-6 bg-color">
        <ul class="pa-0 ma-0 d-flex align-center justify-center">
            <li>{{ itemsOrder.plan.title }}</li>
            <li class="px-3"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.75373 4.473C2.75373 4.473 2.8207 4.50888 2.82383 4.50888C2.16206 3.679 1.48093 2.86107 0.845832 2.00935C0.690982 1.80188 0.611464 1.47274 0.643376 1.21743C0.663255 1.05312 0.974525 0.777529 1.11159 0.801448C1.54004 0.875804 2.03127 0.96888 2.34987 1.23199C3.86384 2.48253 5.35846 3.75907 6.79972 5.09125C7.79944 6.01473 7.71626 6.97929 6.63022 7.81593C5.36526 8.79089 4.07414 9.73308 2.77727 10.6664C1.86177 11.3253 1.00487 11.3694 0.675287 10.824C0.265144 10.1449 0.586876 9.31814 1.51336 8.72121C2.2149 8.26883 4.80445 6.49519 4.78353 6.43383C4.12227 5.79114 3.46102 5.14897 2.79977 4.50628L2.75426 4.47404L2.75373 4.473Z" fill="#201747"/>
    </svg></li>
            <li><strong>Customise</strong></li>
        </ul>
    </div>
    <template v-if="screen1">
        <div class="wrap-plan flex-column px-md-6 ma-md-6 my-6 mb-md-8 d-flex justify-center px-mob">
            <div>
                <h1 class="mb-4">Do you have a food allergy or intolerance?</h1>
            </div>
            <div class="d-flex flex-row justify-center flex-wrap">
                <div class="plan-item ma-1 ma-md-2 py-5 width-add" v-for="(allergieBtn, i) in allergiesBtn" :key="i" @click="setChange(i)" :class="[allergieBtn.isActive ? 'active' : '']">
                    <div>
                        <h2 class="text-center">{{ allergieBtn.title }}</h2>
                    </div>
                </div> 
            </div>
        </div>
        <div class="d-flex justify-center my-6 px-mob">
            <button class="btn-main-app" @click="changeScreen" :disabled="btn1Disabled">{{ changeBtnTitle ? 'Proceed to allergies and intolerances' : 'Proceed to protein preference' }}</button>            
        </div>
    </template>
    <template v-if="screen2">
        <div class="wrap-plan flex-column px-md-6 ma-md-6 my-6 d-flex justify-center px-mob step-allergies">
            <div>
                <h1 class="mb-4">Select any allergies or intolerances you have...</h1>
            </div>
            <div class="d-flex flex-row justify-center flex-wrap">
                <div class="plan-item ma-1 ma-md-2 py-5 allergies" v-for="(allergie, i) in allergies" :key="i" @click="setClassActive(i)" :class="[allergie.isActive ? 'active' : '']" >
                    <div>
                        <h2 class="text-center">{{ allergie.title }}</h2>
                    </div>
                </div>  
            </div>
        </div>
        <div class="d-flex justify-center my-6 px-mob">
            <button class="btn-main-app" @click="nextPage" :disabled="btn2Disabled">Proceed to protein preference</button>            
        </div>
    </template>
</template>

<script>
import Cookies from 'js-cookie'

export default {
    name: 'step-2',
    data() {
        return {
            screen1: true,
            screen2: false,
            btn1Disabled: true,
            btn2Disabled: true,
            changeBtnTitle: true,  
        }
    },
    computed: {
        allergies() {
            return this.$store.getters.getAllergies;
        },
        wizardMenu() {
            return this.$store.getters.wizardMenu;
        },
        itemsOrder() {            
            return this.$store.getters.itemsOrder;
        },
        currentUserData() {
            return this.$store.getters.currentUserData;
        },
        stepItem2Menu() {
            return this.$store.getters.stepItem2Menu;
        },
        allergiesBtn() {
            return this.$store.getters.allergiesBtn;
        },
        setNextPage() {
            return this.$store.getters.setNextPage;
        },
        plansData() {
            return this.$store.getters.basicPlans;
        },
    },
    methods: {
        changeScreen() {
            if(this.allergiesBtn[0].isActive == true) {
                
                this.screen1 = !this.screen1;
                this.screen2 = !this.screen2;

            } 

            if (this.allergiesBtn[1].isActive == true) {                
                
                this.wizardMenu[1].isActive = this.wizardMenu[1].lastItem = false;
                this.wizardMenu[2].isActive = this.wizardMenu[2].lastItem = true;

                Cookies.set('allergiesNo', 'true', { expires: 3600 });

            }
           
        },
        nextPage() {

            let i = 0;
            let and = '';

            this.itemsOrder.customise = '';

            this.allergies.forEach((allergie) => {

                if(allergie.isActive) {
                    if(i > 0) {
                        and = ' and ';
                    } else {
                        and = '';
                    }
                    this.itemsOrder.customise += and + allergie.title;
                    i++;
                }

            });

            if (i == 0 && this.itemsOrder.customise ) {
                this.itemsOrder.customise += 'Allergies';
            }  
            
            this.$store.commit('setItemsOrder', this.itemsOrder);
                        
            this.wizardMenu[1].isActive = this.wizardMenu[1].lastItem = false;
            this.wizardMenu[2].isActive = this.wizardMenu[2].lastItem = true;
            
            if (!this.setNextPage.includes('allergies')) {
                this.setNextPage.push('allergies')
                this.$store.commit('setNextPage', this.setNextPage);
            }
        },
        setClassActive(i) {

            let countActive = 0;
            let allergieCookie = '';

            this.allergies.forEach((allergie, index) => {

                if (index === i) {                    
                    allergie.isActive = !allergie.isActive;  
                }

                if(allergie.isActive == true) {
                    countActive++;
                    allergieCookie += allergie.slug + ',';
                }
            });

            if(allergieCookie.slice(0, -1).length > 0) { 
                Cookies.remove('allergies');
                Cookies.remove('allergiesNo');
                this.currentUserData.allergies = allergieCookie.slice(0, -1);
                this.currentUserData.protein = this.currentUserData.days = '';
                this.currentUserData.breakfastCount = this.currentUserData.mainCount = this.currentUserData.snacksCount = 0;
                           
                Cookies.set('allergies', allergieCookie.slice(0, -1), { expires: 3600 });

            }

            if (countActive > 0) {
                this.btn2Disabled = false;
            } else {
                this.btn2Disabled = true;
            }

        },        
        setChange(i) {
            
            this.allergiesBtn.forEach((btn, index) => {
                
                btn.isActive = false;

                if (index === i) {

                    btn.isActive = !btn.isActive;
                    this.btn1Disabled = false;

                    if(btn.title == 'No') {
                        this.changeBtnTitle = false;
                    } else {
                        this.changeBtnTitle = true;
                    }
                    
                }
                this.$store.commit('setStepItem2Menu', true);

            });
        }
    },
    async beforeMount() {        
        if(this.allergiesBtn[0].isActive != true && this.allergiesBtn[1].isActive != true) {
            
            if(Cookies.get('allergiesNo') == 'true') {
                
                this.allergiesBtn[1].isActive = true;              

                if ( !this.setNextPage.includes('allergies') ) {
                    this.setNextPage.push('allergies')
                    this.$store.commit('setNextPage', this.setNextPage);
                    this.nextPage();
                }

            } else if (Cookies.get('allergies')) {

                let allergies = Cookies.get('allergies').split(',');   
                let dataAllergies = [];

                if (allergies.length > 0) {

                    this.screen1 = false;
                    this.screen2 = true;
                    this.btn1Disabled = false;
                    this.btn2Disabled = false;

                    this.allergies.forEach((allerge) => {

                        if (allergies.some(elem => elem == allerge.slug)) {

                            allerge.isActive = true;
                            dataAllergies.push(allerge.title);
                        }

                    });

                    this.itemsOrder.customise = dataAllergies.join(' free and ') + ' free';
       
                    if ( ! ( this.setNextPage.filter( page => ( page =='allergies') ).length > 0 ) ) {
                        
                        this.setNextPage.push('allergies')
                        this.$store.commit('setNextPage', this.setNextPage);
                        this.nextPage();
                    }

                }

            }
            
        } 

        if (this.allergiesBtn[0].isActive == true) {

            this.changeScreen();

            this.btn1Disabled = false;
            this.btn2Disabled = false;
        }
        
        if (this.allergiesBtn[1].isActive == true) {
            
            this.btn1Disabled = false;
            this.changeBtnTitle = false;

        }

    },

}
</script>

<style scoped  lang="stylus">
.plan-item
    min-width: 35%!important;
    &.width-add {
        width: 48%;
        max-width: 225px;
        min-width: 0!important;

        @media screen and (max-width: 767px) {
            width: 47%;
            margin-bottom: 0!important;
        }
    }

    &.allergies {
         @media screen and (max-width: 767px) {
            min-width: 31%;
            max-width: 45%;
        }    
    }

h1
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;

    @media screen and (max-width: 767px) {
        max-width: 350px;
    }
.breadcrumbs
    ul 
        list-style: none;

.bg-color {
  background: #F1F3F9;
}

.wrap-plan {
    margin-left: auto!important;
    margin-right: auto!important;
    &.d-flex {
        max-width: 1000px;
    }
}
</style>